import Icon from "./IconBase.js";
const InfoIcon = (props) => {
  return (
    <Icon
      width="20"
      height="20"
      viewBox="-5 -2 24 24"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.02 22C17.5429 22 22.02 17.5228 22.02 12C22.02 6.47715 17.5429 2 12.02 2C6.49717 2 2.02002 6.47715 2.02002 12C2.02002 17.5228 6.49717 22 12.02 22Z"
          stroke="#757575"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.02 16V12"
          stroke="#757575"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.02 8H12.03"
          stroke="#757575"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default InfoIcon;
